import { type CryptoCallbacks } from 'matrix-js-sdk/src/crypto-api';
import { type SecretStorage } from 'matrix-js-sdk/src/matrix';

const createSecretStorageCallbacks = () => {
  let secretStorageKeys: Record<string, Uint8Array> = {};
  let secretStorageBeingAccessed = false;

  const cacheSecretStorageKey = (
    keyId: string,
    keyInfo: SecretStorage.SecretStorageKeyDescription,
    key: Uint8Array
  ): void => {
    if (secretStorageBeingAccessed) secretStorageKeys[keyId] = key;
  };

  const getSecretStorageKey: CryptoCallbacks['getSecretStorageKey'] = async ({ keys: keyInfos }) => {
    const keyIds = Object.keys(keyInfos);
    for (const keyId of keyIds) {
      if (secretStorageBeingAccessed && secretStorageKeys[keyId]) {
        return [keyId, secretStorageKeys[keyId]];
      }
    }
    return null;
  };

  const withSecretStorageKeyCache = async <T>(func: () => Promise<T>): Promise<T> => {
    secretStorageBeingAccessed = true;
    try {
      return await func();
    } finally {
      secretStorageBeingAccessed = false;
      secretStorageKeys = {};
    }
  };

  return {
    callbacks: {
      getSecretStorageKey,
      cacheSecretStorageKey,
    } as CryptoCallbacks,
    withSecretStorageKeyCache,
    cacheSecretStorageKey,
  };
};

const {
  callbacks: secretStorageCryptoCallbacks,
  withSecretStorageKeyCache,
  cacheSecretStorageKey,
} = createSecretStorageCallbacks();

export { secretStorageCryptoCallbacks, withSecretStorageKeyCache, cacheSecretStorageKey };
